import { render, staticRenderFns } from "./NewUserRequest.vue?vue&type=template&id=1fe27053&scoped=true"
import script from "./NewUserRequest.vue?vue&type=script&lang=js"
export * from "./NewUserRequest.vue?vue&type=script&lang=js"
import style0 from "./NewUserRequest.vue?vue&type=style&index=0&id=1fe27053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe27053",
  null
  
)

export default component.exports